<template>
   <div class="content_two">
       <div class="box">
           <img src="../assets/images/close.png" class="close" @click="gohome" alt="">
           <div class="left">
               <ul>
                   <li class="libgcone" v-for="(item,index) in infoList.msgs" :key="index" @click="look_info(item.id, infoList, index)">
                       <div class="top">
                           <div class="title">{{item.msg_title}}</div>
                           <div class="date">{{item.create_time}}</div>
                       </div>
                       <div class="text">{{item.msg_content}}</div>
                       <img  v-if="item.is_look==1" src="../assets/images/yidu.png" alt="">
                       <img  v-else src="../assets/images/weidu.png" alt="">
                   </li>
               </ul>
               <div class="pages">
                   <el-pagination
                        small
                        layout="prev, pager, next"
                        :total="infoList.count"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange">
                    </el-pagination>
               </div>
           </div>
           <div class="right">
               <div class="title">{{info.msg_title}}</div>
               <div class="text">{{info.msg_content}}</div>
               <div class="award" v-if="info.prop || info.pet">附件奖励</div>
               <div class="goods">
                   <div  v-for="item in info.prop" :key="item.id" class="goods_bgc">
                       <img :src="item.prop_image" alt="">
                   </div>
                   <div v-if="info.pet" class="goods_bgc">
                       <img :src="info.pet.pet_image" alt="">
                   </div>
               </div>
               <img v-if="info.pet  && info.is_get==0" src="../assets/images/take.png" class="take" alt="" @click="getprize(info.id, info)">
                <img v-if="info.prop  && info.is_get==0" src="../assets/images/take.png" class="take" alt="" @click="getprize(info.id, info)">
           </div>
       </div>
   </div>
</template>
<script>
  export default {
     
      data(){
        return{
            //消息列表
            infoList:[],
            //消息详情
            info:'',
            page: 1,
            per_page: 10,
        }
      },
      created(){
          this.getInfoList();
      },
      methods:{
          gohome(){
              this.$router.replace('/home')
          },
          //获取消息列表
          getInfoList(){
              this.$axios.get(
                  '/api/v1/msg/getmsgs',
                  {
                      params:{
                        page: this.page,
                        per_page: this.per_page,
                      }
                  }
              ).then(res=>{
                  this.infoList=res.data.data
                  this.$msg.warning(res.data.data.hint)
              })
          },
          //查看详情
          look_info(id,infoList, index){
               this.$axios.get(
                  '/api/v1/msg/info',
                  {
                      params:{
                          id:id
                      }
                  }
              ).then(res=>{
                  console.log(res);
                  this.info=res.data.data
                  infoList.msgs[index]['is_look'] = 1;
              })
          },
          //领取
          getprize(id, info){
              this.$axios.post(
                  '/api/v1/msg/get',
                  {
                      id:id
                  }
              ).then(res=>{
                  if(res.data.result_code==200){
                      this.$msg.success(res.data.message)
                      info.is_get = 1;
                  }else {
                      this.$msg.error(res.data.message)
                  }
              })
          },
           handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.per_page=val
                this.getInfoList();

            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.page=val
                this.getInfoList();
            }
      },
      mounted() {
      
      }
  }
</script>
<style scoped>
.box {
    width: 7.73rem;
    height: 4.8rem;
    background: url('../assets/images/info_bgc.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-family: 'Normal';
}
.close {
    width: 0.65rem;
    height: 0.65rem;
    position: absolute;
    top: 0.44rem;
    right: 0;
    cursor: pointer;
}
.left {
    display: inline-block;
    width: 3.3rem;
    height: 70%;
    position: absolute;
    top: 0.85rem;
    left: 0.84rem;
}
ul {
    width: 103%;
    height: 88%;
    overflow: hidden;
    overflow-y: auto;
}
ul::-webkit-scrollbar{
    display:none;
}
li {
    width: 3.3rem;
    height: 0.85rem;
    border-radius: 0.05rem;
    margin-bottom: 0.15rem;
    box-sizing: border-box;
    padding: 0.09rem 0.13rem 0.18rem 0.25rem;
    position: relative;
    cursor: pointer;
}
.libgcone{
    background-color: #B0A48F;
}
.libgctwo{
    background-color: #8E7F63;
}
.left .title {
    width: 50%;
    display: inline-block;
    font-size: 0.18rem;
    font-family: 'Medium';
    font-weight: bold;
    background-image: -webkit-linear-gradient(top,#FCE98F,#E7AB42);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 0.002rem #3B372E ;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.left .date {
    width: 50%;
    display: inline-block;
    float: right;
    font-size: 0.13rem;
    font-family: 'Normal';
    color: #405A39;
    font-weight: bold;
}
.left .text{
    width: 2.93rem;
    font-size: 0.16rem;
    font-family: 'Normal';
    font-weight: bold;
    color: #262A1E;
    overflow : hidden;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
li img {
    width: 0.56rem;
    height: 0.4rem;
    position: absolute;
    bottom: -0.13rem;
    right: -0.13rem;
}
.right {
    width: 3rem;
    height: 63%;
    position: absolute;
    top: 1.1rem;
    right: 0.4rem;
    box-sizing: border-box;
    padding: 0 0.1rem;
    overflow: hidden;
    overflow-y: scroll;
}
.right .title {
    display: inline-block;
    font-size: 0.18rem;
    font-family: 'Medium';
    font-weight: bold;
    background-image: -webkit-linear-gradient(top,#FCE98F,#E7AB42);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 0.002rem #3B372E ;
    margin-bottom: 0.14rem;
}
.right .text {
    /* width: 2.6rem; */
    font-size: 0.16rem;
    font-family: 'Normal';
    font-weight: 400;
    color: #fff;

}
.right .award {
    font-size: 0.16rem;
    font-family: 'Normal';
    font-weight: 400;
    color: #FBE78D;
    margin-top: 0.2rem;
}
.right .goods{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
}
.right .goods_bgc{
    width: 0.51rem;
    height: 0.51rem;
    background: url('../assets/images/goods_bgc.png') no-repeat;
    background-size: 100% 100%;
    margin-top: 0.2rem;
    position: relative;
}
.goods_bgc img {
    width: 75%;
    height: 75%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: 0.5rem;
}
.right .take {
    display: block;
    width: 1.02rem;
    height: 0.39rem;
    margin: 0 auto;
    margin-top: 0.17rem;
}
.pages {
    width: 100%;
    height: 0.3rem;
    margin-top: 0.2rem;
    text-align: center;
}
::v-deep .el-pagination--small .btn-next,
::v-deep.el-pagination--small .btn-prev,
::v-deep.el-pagination--small .el-pager li,
::v-deep.el-pagination--small .el-pager li.btn-quicknext,
::v-deep.el-pagination--small .el-pager li.btn-quickprev,
::v-deep.el-pagination--small .el-pager li:last-child {
    border-color: transparent;
    font-size: 0.1rem;
    font-family: 'Normal';
    line-height: 0.2rem;
    height: 0.2rem;
    min-width: 0.2rem;
}
::v-deep.el-pagination .btn-next,
::v-deep.el-pagination .btn-prev {
    background: center center no-repeat #607839;
    color: #fff;
}
::v-deep .el-dialog,
::v-deep .el-pager li {
    background: #607839 !important;
}
::v-deep .el-pager li.active {
    color: #fff !important;
}
</style>
